

































import { defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import SfBadge from '/storefrontUI/components/components/atoms/SfBadge/SfBadge.vue';
import SfIcon from '/storefrontUI/components/components/atoms/SfIcon/SfIcon.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import type { RemovableFilterInterface } from '~/modules/catalog/category/components/filters/useFilters';
import { FilterTypeEnum } from '~/modules/catalog/category/config/config';

export default defineComponent({
  components: {
    HTMLContent,
    SfBadge,
    SfIcon,
  },
  props: {
    removableFilters: {
      type: Array as PropType<RemovableFilterInterface[]>,
      default: () => [],
    },
  },
  setup() {
    const { app: { i18n } } = useContext();

    const getLabel = (filter: RemovableFilterInterface) => {
      if (filter.type === FilterTypeEnum.YES_NO) {
        const yesNo = filter.label === '1' ? i18n.t('Yes') : i18n.t('No');
        return `${filter.name}: ${yesNo}`;
      }

      return filter.label;
    };

    const objColor = {
      Arancione: '#ff881f', Orange: '#ff881f',
      Silver: '#cccccc', Argento: '#cccccc',
      Light_Blue: '#66a3ff', Azzurro: '#66a3ff',
      Beige: '#ccc195',
      White: '#ffffff', Bianco: '#ffffff',
      Blue: '#004ed6', Blu: '#004ed6',
      Bordeaux: '#8f0d2d',
      Bronze: '#cd7f32', Bronzo: '#cd7f32',
      Yellow: '#f0e739', Giallo: '#f0e739',
      Grey: '#828282', Grigio: '#828282',
      Brown: '#784200', Marrone: '#784200',
      TDM: '#784200', Testa_di_Moro: '#784200',
      Black: '#000000', Nero: '#000000',
      Gold: '#d1af26', Oro: '#d1af26',
      Platinum: '#e5e4e2', Platino: '#e5e4e2',
      Fuxia: '#f400a3',
      Pink: '#eb9beb', Rosa: '#eb9beb',
      Neutral: '', Neutro: '',
      Nude: '#ebc8b2',
      Red: '#d42222', Rosso: '#d42222',
      Copper: '#b87333', Rame: '#b87333',
      Green: '#0e8f07', Verde: '#0e8f07',
      Violet: '#793196', Viola: '#793196',
      Polished_Blue: '#0d1a5e', Blu_Abrasivato: '#0d1a5e',
      Polished_Black: '#1c1a1c', Nero_Abrasivato: '#1c1a1c',
    };

    return {
      getLabel,
      objColor,
    };
  },
});
